// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
  background-color:  #F5F7FA;
  font-family: 'GT Walsheim Trial';
}
.internet-warning {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #d9534f; /* Bootstrap danger color */
  color: white;
  text-align: center;
  padding: 8px 0;
  font-size: 14px;
  font-weight: bold;
  z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,yBAAyB,EAAE,2BAA2B;EACtD,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf","sourcesContent":["body{\n  background-color:  #F5F7FA;\n  font-family: 'GT Walsheim Trial';\n}\n.internet-warning {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: #d9534f; /* Bootstrap danger color */\n  color: white;\n  text-align: center;\n  padding: 8px 0;\n  font-size: 14px;\n  font-weight: bold;\n  z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
